<template>
  <qx-card-form title="明细信息" v-show="orgId">
    <span slot="titleLeft">
      <span class="transAmtText" v-show="otherFormData.transAmt">
        申请总金额：
        <span class="primary">{{otherFormData.transAmt}}</span>
      </span>
    </span>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="vehicleFeeFileDetails" slot-scope="prop">
        <InfoItem
          :orgId="orgId"
          v-model="prop.form.vehicleFeeFileDetails"
          @change="handleDetailChange"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import InfoItem from './infoItem/infoItem';
export default {
  components: {
    InfoItem,
  },
  data () {
    return {
      orgId: '',
      costType: '',
      site: {},
      otherFormData: {
        transAmt: 0, // 申请总金额
        affaires: 0, // 代办处理费
        purchaseFee: 0, // 采购总金额
      },
      baseForm: {
        balanceTypeOptions: [],
        form: [
          {
            label: '明细信息',
            value: 'vehicleFeeFileDetails',
            default: [],
            slot: true,
          },
        ],
        rules: {
          vehicleFeeFileDetails: [ // 明细信息
            { required: true, message: '请选择明细信息', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleDetailChange () {
      const vehicleFeeFileDetails = this.$refs.baseForm.getVal('vehicleFeeFileDetails');
      // 申请金额
      this.otherFormData.transAmt = 0;
      if (vehicleFeeFileDetails) {
        vehicleFeeFileDetails.forEach((item) => {
          if (!isNaN(item.payAmt)) {
            this.otherFormData.transAmt += Number(item.payAmt);
          }
        });
      }
    },
    receiveData (tar, val) {
      this.orgId = val.orgId;
      this.site = {
        serviceName: val.serviceName,
        serviceId: val.serviceId,
        productName: val.productName,
        productId: val.productId,
      };
    },
    async getList () {
      const enumsData = await getEnumList({
        codeType: 'BALANCE_TYPE',
      });
      this.baseForm.balanceTypeOptions = enumsData[0];
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      let res = await this.handleSubData(true);
      return res;
    },

    async sub () {
      let formData = await this.handleSubData();
      const vehicleFeeFileDetails = formData.vehicleFeeFileDetails;
      vehicleFeeFileDetails.forEach((item) => { // 图片处理
        delete item.maintenance;
        if (item.file) {
          item.fileIds = item.file.map((item) => item.id);
          item.fileIds = item.fileIds.join(',');
          delete item.file;
        }
        if (item.beforePicList) {
          item.beforePicFileIds = item.beforePicList.map((item) => item.id);
          item.beforePicFileIds = item.beforePicFileIds.join(',');
          delete item.beforePicList;
        }
        item.linkman = item.userName;
        item.loginAcct = item.mobilePhone;
        // 服务商信息
        item.serviceName = this.site.serviceName;
        item.serviceId = String(this.site.serviceId);
        item.productName = this.site.productName;
        item.productId = String(this.site.productId);
        // 维保信息
        item.flowId = String(item.flowId);
      });
      formData.vehicleFeeFileDetails = JSON.stringify(vehicleFeeFileDetails);
      const last = vehicleFeeFileDetails[vehicleFeeFileDetails.length - 1];
      delete last.maintenanceDetail;
      formData = {
        ...last,
        // plateNumber: last.plateNumber,
        // vehicleCode: last.vehicleCode,
        // licenceType: last.licenceType,
        // userName: last.userName,
        // userId: last.userId,
        // mobilePhone: last.mobilePhone,
        // vehicleFeeFileDetails: formData.vehicleFeeFileDetails,
        ...formData,
        ...this.otherFormData,
      };
      // if (this.$route.query.id) {
      //   formData.serviceRepairPartsList = formData.vehicleFeeFileDetails;
      // delete formData.vehicleFeeFileDetails;
      // }
      return formData;
    },
    init (data = {}) {
      // 详情数据
      if (data.costDetails) {
        data.costDetails.forEach((item) => {
          if (item.fileIds) {
            item.file = item.fileIds.map((item) => ({
              id: item.fileId,
              url: item.fileUrl,
            }));
          }
          if (item.beforePicList) {
            item.beforePicList = item.beforePicList.map((item) => ({
              id: item.fileId || item.id,
              url: item.fileUrl || item.url,
            }));
          }
          // if (item.serviceRepairPartsList) {
          //   item.maintenanceDetail = item.serviceRepairPartsList;
          // }
          // 维保信息
          item.maintenance = {
            contractMobile: item.contractMobile,
            checkAmount: item.checkAmount,
            isNeedBill: item.isNeedBill,
            isNeedBillName: item.isNeedBillName,
            serviceContent: item.serviceContent,
            orderCode: item.orderCode,
            flowId: item.flowId,
          };
        });
        data.vehicleFeeFileDetails = data.costDetails;
      } else if (!data.vehicleFeeFileDetails) {
        data.vehicleFeeFileDetails = [];
      }
      this.$refs.baseForm.setVal('form', data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
.transAmtText {
  margin-left: 16px;
  color: #999;
}
</style>
